import _pt from 'prop-types';
import * as React from 'react';
import Modal from '@ebsco-ui/modal';
import Button from '@ebsco-ui/button';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["acceptButtonStyleType", "acceptButtonText", "acceptButtonIcon", "children", "className", "title", "onAccept", "onReject", "rejectButtonStyleType", "rejectButtonText"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DialogNotification = React.forwardRef(function (_ref, ref) {
  var _ref$acceptButtonStyl = _ref.acceptButtonStyleType,
      acceptButtonStyleType = _ref$acceptButtonStyl === void 0 ? "default" : _ref$acceptButtonStyl,
      acceptButtonText = _ref.acceptButtonText,
      acceptButtonIcon = _ref.acceptButtonIcon,
      children = _ref.children,
      className = _ref.className,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      onAccept = _ref.onAccept,
      onReject = _ref.onReject,
      _ref$rejectButtonStyl = _ref.rejectButtonStyleType,
      rejectButtonStyleType = _ref$rejectButtonStyl === void 0 ? "text" : _ref$rejectButtonStyl,
      rejectButtonText = _ref.rejectButtonText,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getBlocksWith = createBemBlockBuilder(["eb-dialog-notification", className]);
  return /*#__PURE__*/jsxs(Modal, _objectSpread(_objectSpread({}, rest), {}, {
    className: getBlocksWith(),
    onClose: onReject,
    ref: ref,
    children: [/*#__PURE__*/jsxs("div", {
      "data-auto": "dialog-notification-wrapper",
      className: getBlocksWith("__wrapper"),
      children: [/*#__PURE__*/jsx(Modal.Header, {
        closeButtonProps: {
          title: rejectButtonText,
          onClick: onReject
        },
        children: /*#__PURE__*/jsx("h2", {
          className: getBlocksWith("__title"),
          children: title
        })
      }), /*#__PURE__*/jsx(Modal.Body, {
        children: /*#__PURE__*/jsx("section", {
          className: cn(className, getBlocksWith("__body-content")),
          children: /*#__PURE__*/jsx("p", {
            "data-auto": "dialog-notification-body-description",
            className: cn(getBlocksWith("__body-description"), title && getBlocksWith("__body-description--secondary")),
            children: children
          })
        })
      })]
    }), /*#__PURE__*/jsxs(Modal.Footer, {
      children: [/*#__PURE__*/jsx(Button, {
        className: getBlocksWith("__reject-button"),
        onClick: onReject,
        styleType: rejectButtonStyleType,
        children: rejectButtonText
      }), /*#__PURE__*/jsxs(Button, {
        className: getBlocksWith("__accept-button"),
        onClick: onAccept,
        styleType: acceptButtonStyleType,
        children: [acceptButtonIcon && /*#__PURE__*/jsx(FontAwesomeIcon, {
          className: getBlocksWith("__accept-button-icon"),
          icon: acceptButtonIcon
        }), acceptButtonText]
      })]
    })]
  }));
});
DialogNotification.propTypes = {
  acceptButtonText: _pt.string.isRequired,
  children: _pt.node,
  className: _pt.string,
  title: _pt.node,
  onAccept: _pt.func.isRequired,
  onReject: _pt.func.isRequired,
  rejectButtonText: _pt.string.isRequired
};

export { DialogNotification as default };
//# sourceMappingURL=dialog-notification-esm.js.map
